<div class="col-md-12">
  <div class="card card-container">
    <form
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
      <div class="form-title">
        <h1>Mot de passe oublié</h1>
      </div>
      <div class="mt-3 text-left alert alert-warning">
        Entrez votre adresse de courriel ci-dessous et un lien va être envoyé si elle est dans notre système
      </div>
      <div class="form-group">
        <label for="email">Courriel</label>
        <input
          type="email"
          class="form-control"
          name="email"
          [(ngModel)]="form.email"
          required
          email="true"
          #email="ngModel"
        />
        <div *ngIf="email.touched && email.errors?.['email']" class="alert alert-danger" role="alert">
          <span>Entrez un courriel valide.</span>
        </div>
        
        <div class="alert alert-danger" role="alert" *ngIf="email.errors && f.submitted">
          <span>Le courriel est requis!</span>
        </div>
      </div>

      <div class="form-group mt-3">
        <button class="btn btn-primary btn-block">Envoyer</button>
      </div>

      <div class="form-group">
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="email.errors && f.submitted"
        >
          Connexion erronée: {{ errorMessage }}
        </div>
      </div>
    </form>
    <div class="mt-3 text-center">
      <a href="connexion" routerLink="/connexion">Retour à la page de Connexion</a>
    </div>
  </div>

</div>
